<script setup>
    import Store from '../store';
    import { ref, onBeforeMount, watch } from 'vue';
    import Router from '../router';
    import dialogs from '../lib/dialogs';
    import api from '../lib/serverApi';

    import SimpleValue from '../components/widjets/SimpleValue.vue';
    import AnalogClock from '../components/widjets/AnalogClock.vue';
    import DiscretControl from '../components/widjets/DiscretControl.vue';

    const header = ref('');
    const widjets = ref(null);

    async function initDashboard() {
        if (!Router.currentRoute.value.path.includes('/Dashboards/')) return;

        try {
            const formData = await api.getDashboardConfig(Router.currentRoute.value.params.formName);

            header.value = formData.header;
            Store.commit('SET_FORM_HEADER', 'Дашборд > ' + header.value);
            widjets.value = formData.widjets;
        } catch (error) {
            dialogs.showException(error);
        }
    }

    onBeforeMount(() => {
        initDashboard();
    })

    watch(Router.currentRoute, initDashboard);

</script>

<template>
    <div class="dashboardPanel">
        <div class="flex flex-wrap">
            <div v-for="(item, index) in widjets" :key="index">
                <SimpleValue v-if="item.type === 'SYMPLEVALUE'" :config="item" />
                <AnalogClock v-if="item.type === 'ANALOGCLOCK'" />
                <DiscretControl v-if="item.type === 'DISCRETCONTROL'" :config="item" />
            </div>
        </div>
    </div>
</template>

<style scoped>
</style>